import MutationReducer from "./mutation";
import MutationDepositReducer from "./mutation-deposit";
import SettlementSalesReducer from "./settlement-sales";
import StockCardReducer from "./stock-card";

export default{
    mutasi:MutationReducer,
    mutationDeposit:MutationDepositReducer,
    settlementSales:SettlementSalesReducer,
    stockCard:StockCardReducer,
}